module.exports = __webpack_public_path__ + "img/D.6e9bcf33.jpg";